import en from './en.json'
import jp from './jp.json'

/* By default we will serve up a en.json or jp.json file in this project. However, it will be overlaid at runtime by getting
   a tenant-specific version.  Other languages are also retrieved from the server at runtime based on tenant configuration.
   The default en.json is just a placeholder to prevent ugly label names on pages as things are loading.

   Fetch current Ezumee defaults with these endpoints:
        GET https://groups.ezumee.com/api/v1/public/i18n/en
        GET https://groups.ezumee.com/api/v1/public/i18n/jp

 */

export default {
  en, jp
}
